module.exports = __webpack_public_path__ + "images/9819b9092807941aa1d5da1b675736ce.svg";